import { render, staticRenderFns } from "./default.vue?vue&type=template&id=39ae1dc2&"
import script from "./default.js?vue&type=script&lang=js&"
export * from "./default.js?vue&type=script&lang=js&"
import style0 from "./default.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports